import styled from 'styled-components';
import { BigButton } from '../Button/styles';
import { StyleColor } from '../../utils/styles-constants';

export const StyledDownloadAllPopupContent = styled('div')`
	padding: 100px 65px 90px 65px;
	background-color: ${StyleColor.White};
	display: flex;
	flex-direction: column;
	z-index: 12;
	align-items: center;

	position: relative;
	pointer-events: auto;
`;

export const DownloadAllPopupClose = styled('div')`
	position: absolute;
	top: 30px;
	right: 30px;
	cursor: pointer;

	> svg {
		width: 19px;
		height: 19px;
	}
`;

export const DownloadAllPopupLabel = styled('div')`
	font-weight: 600;
	font-size: 18px;
	color: ${StyleColor.Grey800};
	margin-bottom: 35px;
`;

export const StartDownloadAllButton = styled(BigButton)`
	margin-bottom: 30px;
`;

export const KeepForLaterButton = styled(BigButton)`
	background-color: ${StyleColor.Green};
	margin-bottom: 30px;
`;

export const DontAskMeAgainContainer = styled('div')`
	margin-right: auto;
`;

export const DontAskMeAgainLabel = styled('label')`
	margin-left: 10px;
	user-select: none;
`;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/DownloadAllPopupContent/styles.ts